if (!window.customElements.get("component-media-slider")) {
  class ProductsmainSlider extends HTMLElement {

    constructor() {
      super();

      this.selectors = {
        swiper: "swiper-container",
        prevEl: ".custom-prev-button",
        nextEl: ".custom-next-button"
      }

      this.slider = this.querySelector(this.selectors.swiper);
      this.buttonPrev = this.querySelector(this.selectors.prevEl);
      this.buttonNext = this.querySelector(this.selectors.nextEl);
      this.initSlider();
    }

    initSlider() {
      const navigation = this.buttonPrev && this.buttonNext ? {
        nextEl: this.buttonNext,
        prevEl: this.buttonPrev
      } : undefined;

      const swiperParams = {
        slidesPerView: "auto",
        direction: "vertical",
        spacebetween: "8",
        breakpoints: {
          640: {
            slidesPerView: 1,
          },
          990: {
            slidesPerView: 8,
          }
        },
        navigation,
        on: {
          init() {
          }
        },
      };

      Object.assign(this.slider, swiperParams);

      this.slider.initialize();

      requestAnimationFrame(() => this.updateArrowsVisibility());

    }

    updateArrowsVisibility() {
      if (!this.slider) return;

      const slidesCount = this.slider.querySelectorAll('swiper-slide').length;
      if (slidesCount > 8) {
        this.classList.remove('hide-thumb-arrows');
      } else {
        this.classList.add('hide-thumb-arrows');
      }
    }
}

customElements.define('component-thumb-slider', ProductsmainSlider);

class ProductsmainSlider2 extends HTMLElement {

  constructor() {
    super();

    this.selectors = {
      swiper: "swiper-container",
      prevEl: ".custom-prev-button",
      nextEl: ".custom-next-button"
    }

    this.slider = this.querySelector(this.selectors.swiper);
    this.buttonPrev = this.querySelector(this.selectors.prevEl);
    this.buttonNext = this.querySelector(this.selectors.nextEl);
    this.initSlider();
  }

  initSlider() {
    const navigation = this.buttonPrev && this.buttonNext ? {
      nextEl: this.buttonNext,
      prevEl: this.buttonPrev
    } : undefined;

    const swiperParams = {
      slidesPerView: "auto",
      spacebetween: "0",
      thumbs: {
        swiper: '.swipper__thumb',
      },
      pagination: {
        type: "fraction",
      },
      breakpoints: {
        640: {
          slidesPerView: 1,
        },
        990: {
          slidesPerView: 1,
        }
      },
      navigation,
      on: {
        init() {
          if (this.slides.length <= 1) {
            this.pagination.el.remove()
          }
        }
      },
    };

    Object.assign(this.slider, swiperParams);

    this.slider.initialize();

  }
}

customElements.define('component-media-slider', ProductsmainSlider2);
}
